<template>
<div> 
    <v-combobox 
        v-if="can_add_new"
        autocomplete="off"
        :label="(!stylev2) ? label : undefined"
        :value="myValue"
        :items="items"
        :disabled="disabled"
        :background-color="bck_color"
        :item-text="item_text"
        :item-value="item_value"
        :return-object="return_object"
        :loading="loading"
        :search-input.sync="search"
        :filter="filterBy"
        v-bind="vbind"
        v-on="von"
        @input="myInput"
        @change="myChange"
        @input.native="myNativeInput"
        :class="classes"
        :outlined="stylev2" 
        :dense="stylev2"
        :append-icon="(stylev2) ? 'mdi-chevron-down' : undefined" 
    >
        <template slot="item" slot-scope="data">
            {{ data.item[item_search_field] }}
        </template>
        <template v-if="stylev2" v-slot:prepend>
            <label>{{label}}</label>
        </template>
    </v-combobox>
    <v-autocomplete 
        v-else
        autocomplete="off"
        :label="(!stylev2) ? label : undefined"
        :class="(stylev2) ? 'select-invoice-stylev2' : ''"
        :value="myValue"
        :items="items"
        :disabled="disabled"
        :background-color="bck_color"
        :item-text="item_text"
        :item-value="item_value"
        :return-object="return_object"
        :loading="loading"
        @input="myInput"
        :search-input.sync="search"
        :filter="filterBy"
        v-bind="vbind"
        v-on="von"
        :outlined="stylev2" 
        :dense="stylev2" 
        :append-icon="(stylev2) ? 'mdi-chevron-down' : undefined"
    >
        <template slot="item" slot-scope="data">
            {{ data.item[item_search_field] }}
        </template>
        <template v-if="stylev2" v-slot:prepend>
            <label>{{label}}</label>
        </template>
    </v-autocomplete>
</div>
</template>

<script>
import { client } from "@/api/client"

export default {
    name: 'AutocompleteWithApi',
    props: {
        label: {
            type: String,
            required: true
        },
        value: {
            type: [String, Number, Object],
            default: undefined,
        },
        url: {
            type: String,
            required: true
        },
        starting_items: {
            type: Array,
            default: [],
        },
        
        return_object: {
            type: Boolean,
            default: false,
        },
        item_text: {
            type: String,
            default: 'name'
        },
        item_search_field: {
            type: String,
            default: 'name'
        },
        item_value: {
            type: String,
            default: 'id',
        },
        disabled: {
            type: Boolean,
            default: false
        },
        bck_color: {
            type: String,
            default: '#ffffff'
        },
        vbind: {
            type: Object,
            default: undefined
        },
        von: {
            type: Object,
            default: undefined
        },
        stylev2: {
            type: Boolean,
            default: false
        },
        search_field_name: {
            type: String,
            default: 'search_text'
        },
        can_add_new: {
            type: Boolean,
            default: false,
        },
        classes: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            myValue: {},
            items: [],
            search: null,
            loading: false,
            api_call: 0,
        }
    },
    methods: {
        myInput(value) {
            this.myValue = value;
            this.$emit('input', value);
        },
        myNativeInput(value) {
            // let params = {item_search_field: value.target.value};
            // this.$emit('get-values', params);
            this.myInput(value.target.value);
        },
        myChange(value) {
            this.myValue = value;
            this.$emit('change', value);
        },
        getItems(val) {
            this.loading = true;
            let path = this.url;
            if (val) {
                let search_text = encodeURIComponent(val)
                path = path + '&' + this.search_field_name + '=' + search_text;
            }
            this.api_call += 1
            let curr_call = this.api_call       
            client.get(path).then(response => {
                if (curr_call == this.api_call){
                    this.items = response.data.results;
                }
            }).catch(error => { 
                console.debug(error);
            }).finally(() => {
                this.loading = false;
            });
        },
        filterBy(item, queryText, itemText) {
            const text = item[this.item_search_field].toLowerCase();
            const searchText = queryText.toLowerCase();
            return text.indexOf(searchText) > -1;
        },
    },
    mounted() {
        this.myValue = this.value;
        if (this.value && Object.keys(this.myValue).includes(this.item_search_field)) {
            this.getItems(this.myValue[this.item_search_field]);
        } else {
            this.getItems('');
        }
    },
    watch:{
        value(val) {
            this.myValue = val;
            if (val && Object.keys(this.myValue).includes(this.item_search_field)) {
                this.getItems(this.myValue[this.item_search_field]);
            } else {
                this.getItems('');
            }
        },
        search(val) {
            this.getItems(val);
        }
    }
}
</script>

<style scoped>
    /* Select invoice */
    .select-invoice-stylev2 {
        font-size:12px;
        border-radius:2px;
    }
    .select-invoice-stylev2 >>> .v-input__prepend-outer{
        margin-top:2px !important;
        text-wrap:nowrap;
    }
    .select-invoice-stylev2 label {
        color: #454545;
        line-height: 20px;
        font-weight: 600;
    }
    .select-invoice-stylev2 >>> .v-input__slot {
    min-height: 15px !important;
    padding-left:6px !important;
    padding-right:5px !important;
    }
    .select-invoice-stylev2 >>> input {
    padding: 0px !important;
    line-height:25px;
    font-weight: 300;
    }
    .select-invoice-stylev2 >>> .v-input__append-inner {
    margin-top:1px !important;
    padding-left:2px;
    }
    .select-invoice-stylev2 >>> .v-input__icon {
    width: 22px;
    height:22px;
    max-width:22px;
    min-width:22px;
    }
    .select-invoice-stylev2 >>> .v-input__icon .v-icon {
    font-size:18px;
    }

    .select-invoice-stylev2 >>> .v-select__selection--comma {
        margin:0px;
    }
    .select-invoice-stylev2 >>> .v-select__selections {
        padding:0px !important;
    }
    .select-invoice-stylev2 >>> .v-text-field__details {
    margin-bottom:4px;
    }
    .select-invoice-stylev2 >>> .v-text-field__details,
    .select-invoice-stylev2 >>> .v-messages {
        min-height:0px;
        font-size:10px;
    }
    
    /* Select invoice rounded*/
    .select-invoice-stylev2.v-input--is-disabled, 
    .select-invoice-stylev2.v-input--is-readonly {
        border-radius: 20px !important;
    }
</style>